<app-page>
  <dao-coins></dao-coins>
</app-page>
